<template>
  <transition name="fade">
    <div class="modal modal-default">
      <div class="modal__overlay" @click="$emit('close')"></div>
      <div class="small-modal">
        <div class="small-modal__close" @click="$emit('close')">X</div>
        <div class="small-modal__head">
          <span>Attention !</span>
        </div>
        <div class="small-modal__body">
          <div class="small-modal__body__block">
            <div class="small-modal__body__block__content">
              <div class="small-modal__body__block__content--input">
                {{ error.fr }}
              </div>
            </div>
          </div>
        </div>
        <div class="small-modal__footer">
          <div
            class="small-modal__footer__actions d-flex justify-content-between"
          >
            <button class="blue-button" @click.prevent="$emit('close')">
              <span>FERMER</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

  <script>
export default {
  name: "ErrorModal",
  mixins: [],
  components: {},
  props: {
    error: Object,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/components/GarantiesSouscrites/ErrorModal.vue